import { call, put, all, takeLatest } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { getFileNameFromApiResponseHeader } from '../../helpers/utility';
import { onImportCall, onGetImportTemplate, onGetRisksAndPoliciesExportFile } from './api';
import {
  downloadImportTemplate,
  downloadImportTemplateSucceeded,
  downloadImportTemplateFailed,
  exportRisksAndPoliciesExportFile,
  exportRisksAndPoliciesExportFileSucceeded,
  exportRisksAndPoliciesExportFileFailed,
  checkImportFile,
  checkImportFileSucceeded,
  checkImportFileFailed,
  executeImport,
  executeImportSucceeded,
  executeImportFailed
} from './slice';

export function* downloadImportTemplateWorker({ payload = {} }) {
  const { headers, callback } = payload;
  try {
    const requestPayload = headers ? { headers } : {};
    const response = yield call(onGetImportTemplate, requestPayload);
    const filename = getFileNameFromApiResponseHeader(response.headers, '.xlsx');

    if (window.navigator.msSaveOrOpenBlob) {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blob = new File([response.data], filename, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob);
    }

    yield put(downloadImportTemplateSucceeded());

    if (callback && typeof callback === 'function') {
      callback();
    }
  } catch {
    yield put(downloadImportTemplateFailed());
  }
}

export function* checkImportFileWorker({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onImportCall, file, {});
    yield put(checkImportFileSucceeded(response.data));
  } catch {
    yield put(checkImportFileFailed());
  }
}

export function* executeImportWorker({ payload }) {
  const { file } = payload;
  try {
    /* 
      We want to first show the user the import preview and only after he confirms it to execute the import.
      At the same time we use the same endpoint for both actions, so we need to pass an additional parameter that tells the backend 
      if it should execute the import or just return the checked table data for preview. 
    */
    const params = { sandbox_mode: false };
    yield call(onImportCall, file, params);
    yield put(executeImportSucceeded());
  } catch {
    yield put(executeImportFailed());
  }
}

export function* exportRisksAndPoliciesWorker() {
  try {
    const response = yield call(onGetRisksAndPoliciesExportFile);
    const filename = getFileNameFromApiResponseHeader(response.headers, '.xlsx');

    // only IE does support this method
    if (window.navigator.msSaveOrOpenBlob) {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blob = new File([response.data], filename, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      FileSaver.saveAs(blob);
    }

    yield put(exportRisksAndPoliciesExportFileSucceeded());
  } catch {
    yield put(exportRisksAndPoliciesExportFileFailed());
  }
}

export default function* importSaga() {
  yield all([
    takeLatest(executeImport.type, executeImportWorker),
    takeLatest(checkImportFile.type, checkImportFileWorker),
    takeLatest(downloadImportTemplate.type, downloadImportTemplateWorker),
    takeLatest(exportRisksAndPoliciesExportFile.type, exportRisksAndPoliciesWorker)
  ]);
}
